import { createI18n } from 'vue-i18n'
import en from './en.json'
import es from './es.json'
import store from '../store'   // IMPORTA TU VUEX

const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: store.state.user.idioma || 'en',  // lenguaje del usuario
  fallbackLocale: 'en',
  messages: {
    en,
    es
  }
})

export default i18n
